module.exports = __webpack_public_path__ + "potential-en.aab431af.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/PotentialClient/images/potential-en.png
// module id = EoL8
// module chunks = 0